<template>
    <body style="direction: rtl; text-align: right;">
        <Header pageTitle="محفوظاتي" />
        <main class="container d-flex flex-column align-items-center justify-content-center">
            <div class="tabs">
                <button :class="{ active: activeTab === 'posts' }" @click="activeTab = 'posts'">المنشورات</button>
                <button :class="{ active: activeTab === 'freelancers' }"
                    @click="activeTab = 'freelancers'">المُتقنون</button>
            </div>
            <div v-if="loading" class="loading-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div v-else>
                <div v-if="activeTab === 'posts'">
                    <div v-for="post in savedPosts" :key="post.posts_id">
                        <PostCard :post="post" />
                    </div>
                </div>
                <div v-if="activeTab === 'freelancers'">
                    <FreelancerCard v-for="freelancer in savedFreelancers" :key="freelancer.profiles_id"
                        :freelancer="freelancer" />
                </div>
            </div>
        </main>
        <Footer />
    </body>
</template>

<script>
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import axios from 'axios';
import PostCard from "../../components/PostCard.vue";
import FreelancerCard from "../../components/FreelancerCard.vue";

export default {
    name: "MySaves",
    components: {
        Header,
        Footer,
        PostCard,
        FreelancerCard,
    },
    data() {
        return {
            activeTab: 'posts',
            savedPosts: [],
            savedFreelancers: [],
            loading: true,
        };
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        if (userId) {
            this.fetchSavedData(userId);
        } else {
            console.error("User ID غير موجود في Local Storage.");
            this.loading = false;
        }
    },
    methods: {
        async fetchSavedData(userId) {
            try {
                console.log(userId);
                const headers = {
                    'Content-Type': 'multipart/form-data'
                };

                const postsRes = await axios.post(
                    `https://zadcodeonline.com/ahmad/etqan/backEnd/saves/view_post.php`,
                    {
                        userId: userId
                    },
                    { headers }
                );

                const freelancersRes = await axios.post(
                    `https://zadcodeonline.com/ahmad/etqan/backEnd/saves/view_freel.php`,
                    {
                        params: {
                            userId
                        }
                    },
                    { headers }
                );

                this.savedPosts = postsRes.data.data;  // ✅ استخراج البيانات من `data`
                console.log("المنشورات المحفوظة:", this.savedPosts);

                this.savedFreelancers = freelancersRes.data.data; // ✅ استخراج البيانات من `data`
                console.log("المُتقنون المحفوظين:", this.savedFreelancers);

            } catch (error) {
                console.error("خطأ في جلب البيانات", error);
            } finally {
                this.loading = false;
            }
        }
    }

};
</script>

<style scoped>

.loading-overlay {
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
}

.tabs {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}

.tabs button {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    background-color: #eee;
    border-radius: 5px;
    font-size: 16px;
}

.tabs .active {
    background-color: #296080;
    color: white;
}

.post-card,
.freelancer-card {
    background: white;
    padding: 15px;
    margin: 10px 0;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>